import Address from "./Address";
import Item from "./Item";

export default class Order {
	customerName: string;
	customerPhoneNumber: string;
	customerEmail: string;
	pickedUpAtStrauss: boolean;
	deliveryDate: Date;
	items: Array<Item>;
	userId: string;
	id: string;
	status: string;
	createdAt: string;
	tagCode: string;
	storeId: string;
	customerAddress: Address;
	paymentId: string;
	notes: string;

	constructor() {
		this.items = new Array<Item>();
	}
}
